<h2 mat-dialog-title>
    {{ options.title }}
</h2>
<mat-dialog-content>
    @if (options.message) {
        <p class="result-message">
            {{ options.message }}
        </p>
    }
    @if (options.codes.length > 0) {
        <p class="enrollment-code-warning">
            <strong>{{'enrollcode.important' | translate}}</strong>
            {{'enrollcode.last-change-1' | translate}}
            {{'enrollcode.last-chance-2' | translate}}
        </p>
    }
    @if (options.codes.length > 0) {
        <h3>{{'enrollcode.added-enroll-codes' | translate}}</h3>
        <table
            mat-table
            [dataSource]="options.codes"
            class="enrollment-codes-table">
            <ng-container matColumnDef="endpointId">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'endpoints.col.endpoint_id' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.endpointName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'endpoints.col.products' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.product }}
                </td>
            </ng-container>
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>
                    {{'enrollcode.code' | translate}}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.code }}
                </td>
            </ng-container>
            <ng-container matColumnDef="usageLimit">
                <th mat-header-cell *matHeaderCellDef>
                    {{'enrollcode.usage-limit' | translate}}
                </th>
                <td mat-cell *matCellDef="let row">
                    @if (row.usageLimit === -1) {
                        {{ 'UNLIMITED' | translate }}
                    } @else {
                        {{ row.usageLimit }}
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="expiration">
                <th mat-header-cell *matHeaderCellDef>
                    {{'enrollcode.expiration' | translate}}
                </th>
                <td mat-cell *matCellDef="let row">
                    @if (
                        row.expiration === '0' ||
                        row.expiration === 0 ||
                        row.expiration === '-1' ||
                        row.expiration === -1
                    ) {
                        {{ 'PERPETUAL' | translate }}
                    } @else {
                        {{ row.expiration | date:'shortDate' }}
                    }
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns">
            </tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns">
            </tr>
        </table>
    }
    @if (options.failedCodes.length > 0) {
        <h3>{{'enrollcode.failed-enroll-codes' | translate}}</h3>
        <table
            mat-table
            [dataSource]="options.failedCodes"
            class="enrollment-codes-table failed-enrollment-codes-table">
            <ng-container matColumnDef="endpointId">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'endpoints.col.endpoint_id' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.endpointId }}
                </td>
            </ng-container>
            <ng-container matColumnDef="endpointName">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'ENDPOINT' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.endpointName || 'Unknown' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>
                    {{ 'endpoints.col.products' | translate }}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.product }}
                </td>
            </ng-container>
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef>
                    {{'enrollcode.reason' | translate}}
                </th>
                <td mat-cell *matCellDef="let row">
                    {{ row.message }}
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="failedDisplayedColumns">
            </tr>
            <tr
                mat-row
                *matRowDef="let row; columns: failedDisplayedColumns">
            </tr>
        </table>
    }
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
    @if (options.codes.length > 0) {
        <button
            mat-stroked-button
            type="button"
            (click)="downloadCsv()">
            {{'enrollcode.dl-csv' | translate}}
        </button>
    }
    <span class="action-spacer"></span>
    <button
        mat-flat-button
        type="button"
        (click)="close()">
        {{ 'H_CLOSE' | translate }}
    </button>
</mat-dialog-actions>